import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

//Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import { Button } from 'Components';

//Actions
import {
    realtimeMapsDeleteEtaLink,
    etaDeleteReset
} from './redux/slice';

const EtaDelete = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //Redux States
    const { open, loading, error, result, list } = useSelector((state) => state.etaDeleteRedux);

    useEffect(() => {
        return () => {
            handleClose()
        }
    }, []);

    useEffect(() => {
        if (result && open) {
            NotificationManager.success(
                list && list.length > 1 ? messages['eta_delete_success_links'] : messages['eta_delete_success_link'],
                messages['error'],
                3000,
                null,
                null,
                'warning',
            );
            handleClose()
        }
        if (error) {
            NotificationManager.error(
                messages['eta_delete_error_links'],
                messages['error'],
                3000,
                null,
                null,
                'warning',
            );
            dispatch(etaDeleteReset({ error: false }))
        }
    }, [result, open]);

    const handleClose = useCallback(() => {
        dispatch(etaDeleteReset())
    });

    return (
        <Modal
            title={messages['eta_delete_title']}
            open={open}
            position="right"
            size="small"
            className="modal-top-0"
            headerStyle={{ top: 0 }}
            handleClose={handleClose}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>
                    <div>
                        {
                            <p>
                                {
                                    (list && list.length > 1)
                                        ? messages['eta_delete_messages_links'] : messages['eta_delete_messages_link']
                                }
                                {" "}{messages["eta_delete_action_cannot_be_undone"]}
                            </p>
                        }
                    </div>
                    <div>
                        {
                            list?.length > 1 && list.map((item, index) => {
                                return (
                                    <div key={index} className="routes-card routes-container" style={{ marginBottom: 5 }}>
                                        <div>
                                            <strong>{messages['eta_delete_unit']}: </strong>
                                            <span>{item?.unit?.label}</span>
                                        </div>
                                        <div>
                                            <strong>{messages['eta_delete_destination']}: </strong>
                                            <span>{item?.address}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </ModalBody>
            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    disabled={loading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loading}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        let ids = list.map((item) => (item.id))
                        dispatch(realtimeMapsDeleteEtaLink(ids));
                    }}
                    className="btn-red"
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default EtaDelete